import { useDispatch } from "react-redux";
import { jobsActions, JobToastType } from "@shared/slices/jobs.slice";

export const useAddJobToast = (type: JobToastType) => {
  const dispatch = useDispatch();

  const addJobToast = (args: any): number => {
    const id = Date.now();
    dispatch(jobsActions.addActiveJobArgs({ args, id, type }));
    return id;
  };

  const removeJobToast = (id: number, delay = 2000) => {
    dispatch(jobsActions.setActiveJobArgInactive(id));
    setTimeout(() => {
      dispatch(jobsActions.removeActiveJobArgs(id));
    }, delay);
  };

  return { addJobToast, removeJobToast };
};
